module.exports = __webpack_public_path__ + "img/cadbury_danceoff_4.2124a272.jpg";